<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM5,14C5,14,2,14,2,14C2,14,2,2,2,2C2,2,5,2,5,2C5,2,5,14,5,14C5,14,5,14,5,14ZM14,14C14,14,6,14,6,14C6,14,6,2,6,2C6,2,14,2,14,2C14,2,14,14,14,14C14,14,14,14,14,14ZM8,9C8,9,12,9,12,9C12.55,9,13,8.55,13,8C13,7.45,12.55,7,12,7C12,7,8,7,8,7C7.45,7,7,7.45,7,8C7,8.55,7.45,9,8,9C8,9,8,9,8,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'RemoveColumnRight',
} as DefineComponent
</script>
